export default __webpack_public_path__ + "static/button-action-do-af6c06a26f649d0fc290349bbd13baea91eb7058dfd13bd72d5bd397cca58097.png";